import { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { getEnvVariables } from "../../utils/helpers/getEnvVariables";

const SelectAsyncPaginateLocalidades = (props) => {
  const [itemsDonwload, setItemsDonwload] = useState({});
  const { API_URL } = getEnvVariables();

  const getDefaultValue = async () => {
    if (props.id) {
      const response = await fetch(
        `${API_URL}/utils/localidades/`
      );
      const resp = await response.json();
      const defaultValue = resp.results.filter(item => item.id === props.id)[0]
      props.onChange(defaultValue)
    }
  }

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    let resp = itemsDonwload;
    let nextHas = null;
    if (searchQuery.length == 0) {
      const response = await fetch(
        `${API_URL}/utils/localidades/`
      );
      resp = await response.json();
      setItemsDonwload({
        ...resp,
        results: [...resp.results, ...(itemsDonwload?.results || [])],
      });
      nextHas = resp.next
    } else {
      resp = itemsDonwload
    }
    return {
      options: resp.results,
      hasMore: nextHas !== null,
      additional: {
        page: searchQuery ? 2 : page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  return (
    <AsyncPaginate
      styles={props.styles}
      key={JSON.stringify()}
      value={props.value || getDefaultValue || ""}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.nombre}
      getOptionLabel={(option) => option.nombre}
      onChange={onChange}
      placeholder="Seleccionar"
      additional={{
        page: 1,
      }}
      isSearchable
      filterOption={(option, inputValue) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
    />
  );
};

export default SelectAsyncPaginateLocalidades;